import { render, staticRenderFns } from "./PosCatalog.vue?vue&type=template&id=70a6d027"
import script from "./PosCatalog.vue?vue&type=script&lang=js"
export * from "./PosCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports